
import utils from '@/components/tools/utils'
import CallToAction from '@/components/strapi/CallToAction'
import { StructuredData } from '@/helpers/structuredData'

export default {
  name: 'Cm24Article',
  components: {
    CallToAction,
    RecentArticles: () => import('@/components/strapi/RecentArticles.vue')
  },
  props: {
    outlined: {
      type: Boolean,
      default: false

    },
    flat: {
      type: Boolean,
      default: false

    },
    content: {
      type: Object,
      default: () => {
      }
    }
  },

  head () {
    return {
      title: this.title,
      script: this.script,

      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.description
        },
        {
          hid: 'description',
          name: 'description',
          content: this.description
        },
        {
          hid: 'og:type',
          name: 'og:type',
          content: 'article'
        },
        {
          name: 'og:image',
          content: this.image
        },
        {
          name: 'og:url',
          content: this.fullUrl
        }
      ]
    }
  },

  computed: {
    fullUrl () {
      if (process.server && this.$ssrContext) {
        // Server-side: Use $ssrContext to get the req object
        const protocol =
          this.$ssrContext.req.headers['x-forwarded-proto'] || 'http'
        const host = this.$ssrContext.req.headers.host
        const path = this.$ssrContext.req.url
        return `${protocol}://${host}${path}`
      } else if (process.client) {
        // Client-side: Use window.location to get the full URL
        return window.location.href
      } else {
        return undefined
      }
    },
    script () {
      const sd = new StructuredData()
      const fullLinkToAuthor = this.$config.baseURL + this.authorUrl

      return sd.articleToScriptAndStructuredData(this.content, fullLinkToAuthor)
    },
    url () {
      return this.content?.url
    },
    hero () {
      return this.content?.hero
    },
    title () {
      return this.content?.title
    },
    description () {
      return this.content?.description
    },
    createdAt () {
      if (this.content?.createdAtOverride) {
        return utils.formatDateWithoutTime(this.content?.createdAtOverride, this.$i18n.locale)
      } else {
        return utils.formatDateWithoutTime(this.content?.createdAt, this.$i18n.locale)
      }
    },
    image () {
      return this.content?.image?.data?.attributes?.url
    },
    mainImageAlt () {
      return this.content?.altImage
    },
    blocks () {
      return this.content?.blocks
    },
    contentBlocks () {
      return this.content?.blocks?.filter(block => block.anchor)
    },
    richText () {
      return this.content?.richText
    },
    author () {
      return this.content?.author?.data?.attributes
    },
    tags () {
      return this.content?.tags.data.map(tag => tag.attributes.tag)
    },
    footnote () {
      return this.content?.footnote
    },
    numberOfWords () {
      return this.content?.blocks?.filter(block => block.anchor)
        .map(block => block.content).join(' ').split(' ').length
    },
    readTime () {
      // TODO add 12 seconds for each image in the article
      return Math.ceil(this.numberOfWords / 275)
    },
    authorUrl () {
      if (!this.author) {
        return ''
      }

      return this.localePath({ name: 'blog-author-slug', params: { slug: this.author.url } })
    },
    authorImage () {
      return this.author?.image?.data?.attributes?.url
    },
    authorName () {
      return this.author?.name
    },
    authorJobTitle () {
      return this.author?.jobTitle
    }
  },

  methods: {

    relativeImageUrl (image) {
      const url = image?.data?.attributes?.url?.replace(/^.*\/\/[^/]+/, '')
      return url || ''
    }
  }
}
